//---------------------------------------------------
//  Nom du fichier : Signalement.js 
//
//  Description: Component qui gère le signalement de publication, commentaire et profil
//
//  Auteur: Vega Laliberté et Alek Del Balso
//---------------------------------------------------

import './Signalement.css';
import { useState } from "react";
import {callAPI} from './callAPI.js'
import { useTranslation } from 'react-i18next';
import Background from './background.js';
import Button from '@mui/material/Button';

function Signalement({from, open_signalement, id, comment_id, idChange}) {

    const [raison, setRaison] = useState("Harcèlement")
    const { t } = useTranslation();

    const send_signalement = () => {
        const form = new FormData()
        form.append('type', 'signalement')
        form.append('from', from)
        form.append('raison', raison)
        form.append('id', id)
        form.append('comment_id', comment_id)

        callAPI("write", form)
        .then((data) => {
          open_signalement(false)
        })
        .catch((error) => {
            console.error("API call failed:", error);
        });
      }


    return (
        <Background  func={() => {open_signalement(false)}}>
            <div id={idChange} className="signalementContainer">
                <div className='titleAndIconSignalement'>
                    <div>{t('report_reason')}</div>
                    <span className="material-symbols-outlined iconSignaler">report</span>
                </div>
                <div className='selectorAndTitle'>
                    <div className='raisonSignalement'>{t('report_reason')}</div>
                    <select 
                        name="raison" 
                        className='SelectorRaison'
                        onChange={e => setRaison(e.target.value)}>
                    <>
                        <option>{t('report_1')}</option>
                        {from == "publication" ? <option>{t('report_2')}</option> : ""}
                        <option>{t('report_3')}</option>
                        <option>{t('report_4')}</option>
                        <option>{t('report_5')}</option>
                        <option>{t('report_6')}</option>
                        <option>{t('report_7')}</option>
                        <option>{t('report_8')}</option>
                        <option>{t('report_9')}</option>
                        <option>{t('report_10')}</option>
                        <option>{t('report_11')}</option>
                        <option>{t('report_12')}</option>
                    </>
                    </select>
                </div>
                <div className='buttonSignalementDiv'>
                    <Button variant="outlined" className='btBase' onClick={() =>{send_signalement()}}>Envoyer</Button>
                    <Button variant="outlined" id='cancelModify' className='btBase' onClick={() =>{open_signalement(false)}}>Anuller</Button>
                </div>
            </div>
        </Background>
    );
  }
  
  export default Signalement;